import "../../assets/scss/Components/Modal/modal.scss";
import { Button } from "../Button/Button";
import { VarianButtonEnum } from "../../enum/Button/variantButton.model";
import { colorButton } from "../../enum/Button/colorButton.model";
import { Typography } from "../../components/typography";
import { IconModelEnum } from "../../enum/Button/iconButton.model";
import DataContainer from "../../services/DataContainer";
import { ContactDealerFormSettings } from "../../enum/enums";

type ContactFormThankYouModalProps = {
  setContactFormModalOpen: (open: boolean) => void;
  salesforceStatus?: string;
  salesforceMessage?: string;
};

export const ContactFormThankYouModal = ({
  setContactFormModalOpen,
  salesforceStatus,
  salesforceMessage,
}: ContactFormThankYouModalProps) => {
  return (
    <div className="email-modal h-full top-2/4 left-2/4 z-30 fixed -translate-y-1/2 -translate-x-1/2">
      <div className="fixed top-2/4 left-2/4 -translate-y-1/2	 -translate-x-1/2">
        <div className="thank-you--modal bg-white border border-gray-suva relative">
          <div className="p-6">
            <Button
              variant={VarianButtonEnum.DEFAULT}
              icon={IconModelEnum.CLOSE_GREY}
              bgColor={colorButton.WHITE}
              onClickEvent={() => setContactFormModalOpen(false)}
              customClassNames="absolute z-1 border p-2 cursor-pointer opacity-50  border border-gray-stone right-6 top-6"
            />
            <div className="flex flex-col items-center justify-center mt-10">
              <Typography tag="h3" className="text-2xl mb-6 text-light-grey">
                {(salesforceStatus === "Failure" || salesforceStatus === "Error") ? salesforceMessage : DataContainer.sectionKey(ContactDealerFormSettings.CONTACT_DEALER_FORM, ContactDealerFormSettings.MESSAGE_SENT_TEXT)}
              </Typography>
              <Button
                customClassNames="ml-6 mt-8"
                variant={VarianButtonEnum.SENDBUTTON}
                text={DataContainer.sectionKey(ContactDealerFormSettings.CONTACT_DEALER_FORM, ContactDealerFormSettings.CLOSE_BUTTON_TEXT)}
                textTransform={true}
                rounded={false}
                bgColor={colorButton.BLUE_LIGHT}
                onClickEvent={() => setContactFormModalOpen(false)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
